import { UiEvent } from 'src/utils/analytics/publish';

export const uiEvents: {
  [event: string]: UiEvent;
} = {
  inlineStopButton: {
    action: 'clicked',
    source: 'pipelinesInlineStopButton',
    actionSubject: 'pipelinesInlineStopButton',
    actionSubjectId: 'pipelinesInlineStopButtonId',
  },
};
